import Navbar from "@/components/core/Navbar";
import { Footer } from "@/components/core/Footer";
import { Form, Button, message, Input, Select, Checkbox } from "antd";
import { useState } from "react";
import { FeedbackI, sendFeedback } from "@/services/Feedback/sendFeedback";

const { TextArea } = Input;

export const FeedBack = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const handleSubmit = async (values: FeedbackI) => {
        setLoading(true);
        try {
            await sendFeedback(values);
            messageApi.success("Bildirim başarıyla gönderildi!");
            form.resetFields();
        } catch (err) {
            messageApi.error("Gönderirken hata oluştu.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: "var(--color-bg)",
            }}
        >
            {contextHolder}
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                style={{ maxWidth: '800px', width: '100%', padding: '20px' }}
            >
                <p
                    style={{
                        fontSize: '14px',
                        marginBottom: '12px',
                        lineHeight: 1.5,
                        backgroundColor: '#d9d9d9',
                        padding: '10px',
                        borderRadius: '10px',
                        marginTop: '20px',
                    }}
                >
                    Herhangi bir konuda site veya makaleler ile ilgili öneri, şikayet vb. bildirebilirsiniz.
                    {<br></br>}Bildirimleri sadece admin görüntüleyebilir. Lütfenst üste çok fazla bildirim göndermeyiniz.
                </p>
                <Form.Item name="category" label="Kategori" rules={[{ required: true }]}>
                    <Select placeholder="Kategori seçin">
                        <Select.Option value="general">Genel</Select.Option>
                        <Select.Option value="article">Makale</Select.Option>
                        <Select.Option value="bug">Hata / Sorun</Select.Option>
                        <Select.Option value="suggestion">Öneri</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="title"
                    label="Başlık"
                    rules={[{ required: true, message: "Başlık gerekli" }]}
                >
                    <Input placeholder="Kısa bir başlık girin" />
                </Form.Item>

                <Form.Item
                    name="message"
                    label="Mesajınız"
                    rules={[{ required: true, message: "Mesaj gerekli" }]}
                >
                    <TextArea rows={5} placeholder="Mesajınızı yazın..." />
                </Form.Item>

                <Form.Item
                    name="agreement"
                    valuePropName="checked"
                    rules={[
                        {
                            validator: (_, value) =>
                                value ? Promise.resolve() : Promise.reject(new Error("Bu kutucuğu işaretlemeden gönderemezsiniz")),
                        },
                    ]}
                >
                    <Checkbox>
                        Gönderim yapmadan önce lütfen <b>saygı çerçevesinde</b> bir bildirim yaptığınızdan emin olun
                    </Checkbox>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Gönder
                    </Button>
                </Form.Item>
            </Form>
        </div >
    );
};